
import Vue from 'vue'
import Detail from './index.vue'
import { Page } from '@/page'
import selectArea from '@/plugins/select-area'
import selectVariant from '@/plugins/select-variant'
import selectCoupon from '@/plugins/select-coupon'
import Exposure from '@/plugins/exposure'
import Login from '@/plugins/login'

Vue.use(Exposure)
Vue.use(selectArea)
Vue.use(selectVariant)
Vue.use(selectCoupon)
Vue.use(Login)

Page("product-detail", {
  el: '#app',
  template: '<Detail/>',
  components: { Detail },
  pageType: '商品详情页'
})



// WEBPACK FOOTER //
// ./static/app-product-detail/index.js